import styled from "styled-components";


export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;


export const Search = styled.div`
  margin: 1rem;
  height: 3rem;
`;
